export const PART_DETAIL_PAGE_EVENT = "Part Detail Page";
export const PART_DETAIL_PAGE_STEPS = {
  ENTRY: "Entry",
  MARK_AS_VERIFIED_SUCCESS: "Marked as verified success",
  MARK_AS_VERIFIED_FAILED: "Marked as verified failed"
};
